import { useAuthStore } from '../stores/auth.store';
import { resolveApiBaseUrl } from '../../api/utils/api-base-url';

const getAuthBackendUrl = (): string => resolveApiBaseUrl() ?? 'http://localhost:8080';

export const useAuth = () => {
  const { user, authErrorMessage, sessionExpired, setAuthErrorMessage, setSessionExpired, logout: clearUser } = useAuthStore();

  const login = () => {
    setAuthErrorMessage(null);
    setSessionExpired(false);
    const currentUrl = encodeURIComponent(window.location.origin);
    const backendUrl = getAuthBackendUrl();
    window.location.href = `${backendUrl}/login?redirect=${currentUrl}`;
  };

  const logout = () => {
    setAuthErrorMessage(null);
    setSessionExpired(false);
    clearUser();
    const currentUrl = encodeURIComponent(window.location.origin);
    const backendUrl = getAuthBackendUrl();
    window.location.href = `${backendUrl}/logout?redirect=${currentUrl}`;
  };

  const isAuthenticated = !!user;
  const impersonating = !!user?.isImpersonating;
  const permissions = user?.permissions ?? [];
  const branchScopeKey = JSON.stringify([
    user?.id, user?.branchSource, user?.organisationType,
    (user?.branches ?? []).map((branch) => branch.id).sort(), impersonating,
  ]);

  return {
    user,
    authErrorMessage,
    sessionExpired,
    isAuthenticated,
    impersonating,
    permissions,
    branchScopeKey,
    login,
    logout,
  };
};
